import { useState, useCallback } from "react";
import { Area, Point } from "react-easy-crop";

export const useImageCrop = () => {
    const [crop, setCrop] = useState<Point>({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [croppedArea, setCroppedArea] = useState<Area | null>(null);

    const onCropComplete = useCallback((_: Area, croppedAreaPixels: Area) => {
        setCroppedArea(croppedAreaPixels);
    }, []);

    const reset = () => {
        setCrop({ x: 0, y: 0 });
        setZoom(1);
        setCroppedArea(null);
    };

    return {
        crop,
        zoom,
        croppedArea,
        setCrop,
        setZoom,
        onCropComplete,
        reset,
    };
};
